import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  DocsUploadFormValues,
  FormDataRequestObject,
} from '../../../../../types';
import { handleSuccess } from '../../../../../utils/admin';
import { useRequestConstructor } from '../../../../hooks/useRequestConstructor';
import { APPLICATION_BASE_PATH } from '../../constants/applicationBasePath';
import { postUploadApplicationDoc } from '../../requests/postUploadApplicationDoc';

export const useUploadApplicationDoc = (definitionName: string) => {
  const queryClient = useQueryClient();
  const { constructPost } = useRequestConstructor();

  const { mutateAsync: uploadDoc, ...rest } = useMutation({
    mutationFn: ({
      uuid,
      data,
    }: {
      uuid: string;
      data: FormDataRequestObject<DocsUploadFormValues>;
    }) => postUploadApplicationDoc(constructPost, uuid, definitionName, data),
    onSuccess: (_, { uuid }) => {
      handleSuccess('Success');
      queryClient.invalidateQueries({
        queryKey: [APPLICATION_BASE_PATH, uuid, 'docs'],
      });
    },
  });

  return { uploadDoc, ...rest };
};
